<template>
	<div class="form-mdfpwd">

		<el-form ref="form" :model="form" :rules="rules" label-width="" :disabled="isLook">
			<div class="pwdhead">
				<span class="pwdtitle">修改设备素材</span>
				<div class="closediv" @click="close"><span class="close"></span></div>
			</div>
			<div class="content_left clearfix">
				<el-form-item label="名称：" prop="name">
					<el-input placeholder="请输入设备名称" v-model="form.name" @keyup.enter.native="submitForm('form')" clearable> </el-input>
				</el-form-item>
				<el-form-item label="分类：" prop="classify">
					<div class="robotname">
						<el-select v-model="form.classify" placeholder="未分类"  clearable>
							<el-option v-for="(item,index) in TypeOptions" class="classifyOpa" :key="index" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</el-form-item>
				<el-form-item label='图片'>
					<div class="file_img">
						<input style="display: none;" type="file" id="upload_file_DeviceMdf" ref="addfile" class="file" accept="image/*">
						<span class="file_img_span" @click="clickFile('add')">上传图片</span>
						<div class="position_body">
							<img class="position_xyImg" :src="xyImg" />
							<img class="position_xyzImg" :src="xyzImg" />
							<div class="fileImgShow" ref='addImg'>
								<!--<div class="test-box" style="left: 50px;top: 50px;"></div>-->
								<img class="NowLogo" :src="logo"/>
								<img class="errorLight" v-if="propertie.hasAlarmLight" :style="{'top': propertie.alarmLightY+'px','left': propertie.alarmLightX+'px'}" src="../../../assets/image/material/errorLight.png" />
								<!--<img class="errorLight" v-if="propertie.hasStateLight" :style="{'top': propertie.stateLightY+'px','left': propertie.stateLightX+'px'}" src="../../../assets/image/material/green.png" />-->
								<img class="errorLight" v-if="propertie.hasProgressBar" :style="{'top': propertie.progressBarY+'px','left': propertie.progressBarX+'px'}" src="../../../assets/image/material/blue.png" />
								<div class="connectPoint" :style="{'top': item.y+'px','left': item.x+'px'}" v-for="(item,index) in ConnectPoint"><div>{{index+1}}</div></div>
							</div>
						</div>
					</div>
					<div class="el-form-item__errorMy" :class="{active:errorMyImg}">
						请上传图片
					</div>
				</el-form-item>
				<el-form-item label="备注：">
					<el-input placeholder="请输入描述" type="textarea" resize="none" v-model="form.remark" @keyup.enter.native="submitForm('form')" clearable> </el-input>
				</el-form-item>
			</div>
			<div class="content_right clearfix">
				<div class="right_ top__ clearfix">
					<p>附加控件选择</p>
					<div class="top_box">
						<el-checkbox v-model="propertie.hasAlarmLight">报警灯</el-checkbox>
						<div class="top_content" :class="{active:propertie.hasAlarmLight}">
							<span class="title">坐标</span>
							<div class="positionXY">
								<span>X</span>
								 <!--:min="-65" :max="205"-->
								<el-input-number :step="1" v-model="propertie.alarmLightX" :disabled="!propertie.hasAlarmLight"></el-input-number>
							</div>
							<div class="positionXY">
								<span>Y</span>
								 <!--:min="-30" :max="180"-->
								<el-input-number :step="1" v-model="propertie.alarmLightY" :disabled="!propertie.hasAlarmLight"></el-input-number>
							</div>
						</div>
					</div>
					 <!--:min="-50" :max="230"-->
					 <!--:min="-20" :max="205"-->
					<!--<div class="top_box">
						<el-checkbox v-model="propertie.hasStateLight">状态指示灯</el-checkbox>
						<div class="top_content" :class="{active:propertie.hasStateLight}">
							<span class="title">坐标</span>
							<div class="positionXY">
								<span>X</span>
								
								<el-input-number :step="1" v-model="propertie.stateLightX" :disabled="!propertie.hasStateLight"></el-input-number>
							</div>
							<div class="positionXY">
								<span>Y</span>
								
								<el-input-number :step="1" v-model="propertie.stateLightY" :disabled="!propertie.hasStateLight"></el-input-number>
							</div>
						</div>
					</div>-->
					<div class="top_box">
						<el-checkbox v-model="propertie.hasProgressBar">进度条</el-checkbox>
						<div class="top_content" :class="{active:propertie.hasProgressBar}">
							<span class="title">坐标</span>
							<div class="positionXY">
								<span>X</span>
								 <!--:min="-48" :max="234"-->
								<el-input-number :step="1" v-model="propertie.progressBarX" :disabled="!propertie.hasProgressBar"></el-input-number>
							</div>
							<div class="positionXY">
								<span>Y</span>
								 <!--:min="-20" :max="125"-->
								<el-input-number :step="1" v-model="propertie.progressBarY" :disabled="!propertie.hasProgressBar"></el-input-number>
							</div>
						</div>
					</div>
				</div>
				<div class="right_ bottom__ clearfix">
					<p>连接点选择</p>
					<div class="overAuto">
						<div class="top_box" v-for="(item,index) in ConnectPoint">
							<span class="ljd_name">连接点{{index+1}}</span>
							<span class="ljd_cx">朝向</span>
							<el-select v-model="item.type" placeholder="请选朝向">
								<el-option v-for="(item,index) in joinPoints" class="classifyOpa" :key="index" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<div class="top_content">
								<span class="title">坐标</span>
								<div class="positionXY">
									<span>X</span>
									<el-input-number :step="1" :min="-43" :max="237" v-model="item.x"></el-input-number>
								</div>
								<div class="positionXY" style="margin-right: 0;">
									<span>Y</span>
									<el-input-number :step="1" :min="-15" :max="211" v-model="item.y"></el-input-number>
								</div>
							</div>
							<span class="ljd_sc blueSpan" @click="delConnectPoint(index)">删除</span>
						</div>
					</div>
					<p class="blueSpanAdd" :class="{'gray':ConnectPoint.length==6}" @click="AddConnectPoint">+添加</p>
				</div>
			</div>
			<div style="position: absolute;bottom: 20px; width: 100%; text-align: center;">
			  <el-button type="primary" @click="submitForm('form')" style="margin-right: 15px;">确定</el-button>
			  <el-button @click="close()">取消</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	export default {
		name: 'mdfpwd',
		data() {
			var validatePass = (rule, value, callback) => {
				if(!value) {
					callback(new Error('请填写名称'));
				} else {
					callback();
				}
			};
			var validatePass1 = (rule, value, callback) => {
				if(!value) {
					callback(new Error('请选择分类'));
				} else {
					callback();
				}
			};
			return {
				
				propertie:{
					hasAlarmLight: false, //报警灯
					alarmLightX: 0, //X
					alarmLightY: 0, //Y
	
					hasStateLight: false, //状态指示灯
					stateLightX: 0, //X
					stateLightY: 0, //Y
	
					hasProgressBar: false, //进度条
					progressBarX: 0, //X
					progressBarY: 0, //Y
				},
				form: {
					id: '', //编号
					name: '', //名称
					classify: '', //分类
					Imgfile: '', //图片地址base64
					remark: '', //备注
				},
				formdata: '',
				formdataFile: '',
				xyImg: require('@/assets/image/material/xyImg.png'),
				xyzImg: require('@/assets/image/material/xyzImg.png'),

				logo: require('@/assets/image/material/logo.png'),//当前显示的图片地址
				UploadUrl: '',//当前所上传的图片位于服务器的图片路径
				logoSizeMark: false,
				errorMyImg: false, //是否上传图片
				TypeOptions: [], //分类数组
				joinPoints: [{
						id: 1,
						name: '正面'
					},
					{
						id: 2,
						name: '侧面'
					},
					{
						id: 3,
						name: '上面'
					},
				],
				ConnectPoint: [],//连接点
				rules: {
					name: [{
						required: true,
						validator: validatePass,
						trigger: 'change'
					}],
					classify: [{
						required: true,
						validator: validatePass1,
						trigger: 'change'
					}]
				}
			}
		},
		computed: {
			...mapState("defaultImgOptions", {
				ImageBaseUrl: 'ImageBaseUrl',
			}),
			isLook() {
				return this.$store.state.isLook;
			},
		},
		methods: {
			AddConnectPoint(){
				if(this.ConnectPoint.length < 6){
					this.ConnectPoint.push({
						type: 1,
						x: 0,
						y: 0
					})
				}
			},
			delConnectPoint(index){
				if(this.isLook)return;
				this.ConnectPoint.splice(index,1)
			},
			binding(data,mothFather) {
				this.logoSizeMark = true;
				this.form.id = data.id;
				this.form.name = data.name;
				this.form.classify = data.categoryId;
				this.logo = this.ImageBaseUrl + data.image;
				this.UploadUrl = data.image;
				this.form.remark = data.note;
				this.ConnectPoint = JSON.parse(data.joinPoint);
				this.propertie = JSON.parse(data.propertie)[0];
				this.TypeOptions = JSON.parse(JSON.stringify(mothFather)).splice(1);
			},
			clickFile(name) {
				if(this.isLook)return;
				let fileName = name + 'file';
				let imgName = name + 'Img';
				let inp = this.$refs[fileName];
				inp.click();
				let that = this;
				inp.onchange = function(e) {
					let fileList = that.$refs[fileName].files; //获取上传文件
					let file = fileList[0]; //文件参数
					let size = file.size / 1024; //文件大小
					const fileReader = new FileReader()
					fileReader.readAsDataURL(file) //读取图片
					fileReader.addEventListener('load', function() {
//						that.logo = fileReader.result; // 读取完成
						that.form.Imgfile = fileReader.result;//图片base64地址
						var blob = that.dataURItoBlob(fileReader.result);
						that.upload(blob); //执行上传接口
					})
					if(size / 1024 > 1) {
						that.logoSizeMark = false;
						that.$alert('上传文件不可大于1M', '信息', {
							confirmButtonText: '确定'
						});
						return
					} else {
						that.errorMyImg = false;
						that.logoSizeMark = true;
					}
				}
			},
			upload(imgUrl){
                this.formdataFile = new FormData();
                this.formdataFile.append('file',imgUrl);//下面是要传递的参数
                
                this.postForm('/Control/upload', this.formdataFile).then((res) => {
					this.UploadUrl = res;
					this.logo = this.ImageBaseUrl + res;
				})
            },
			dataURItoBlob (dataURI) {
                let byteString = window.atob(dataURI.split(',')[1]);
                let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                let T = mimeString.split('/')[1];
                let ab = new ArrayBuffer(byteString.length);
                let ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ab], {type: mimeString});
            },
			submitForm(formName) {
				if(this.isLook)return;
				this.$refs[formName].validate(valid => {
					if(!valid) {
						if(!this.logoSizeMark) {
							this.errorMyImg = true;
						}
					}
					if(valid) {
						//如果通过验证 to do...
						if(!this.logoSizeMark) {
							this.errorMyImg = true;
						} else {
							//隐藏
							this.$parent.Mdfrobot();
							let data = {};
							data.id = this.form.id;
							data.name = this.form.name;
							data.categoryId = this.form.classify;
							data.image = this.UploadUrl;
							data.note = this.form.remark;
							data.properties = [this.propertie];
							data.joinPoints = this.ConnectPoint;
							this.postNoJson('/Control/update', data).then((res) => {
								if(res.success == true) {
									this.$message({
							          showClose: true,
							          message: '修改成功',
							          type: 'success'
							       });
									//更新分类
									this.$parent.TypeListUpdata();
									//更新表单
									//this.$parent.TableDataUpdata();
									//清楚校验结果
									this.$refs.form.resetFields();
								}
							})
						}
					}
				})
			},
			close() {
				this.$parent.Mdfrobot();
			}
		}
	}
</script>

<style scoped>
	.gray{
		color: #C2C2C2 !important;
		cursor: not-allowed !important;
	}
	.fileImgShow{
		background-position: left top;
		background-repeat: no-repeat;
	}
	.connectPoint{
		position: absolute;
	    left: 0;
	    right: 0;
	    top: 0;
	    bottom: 0;
	    width: 10px;
	    height: 10px;
	    background-color: #5087E4;
	    border-radius: 50%;
	    line-height: 11px;
	    font-size: 12px;
	    color: #fff;
        margin-left: -5px;
    	margin-top: -5px;
	}
	.connectPoint div{
		transform: scale(.75);
	    position: relative;
	    left: 1px;
	}
	.overAuto{
	    max-height: 250px;
		width: 100%;
		/*overflow-y: auto;
		overflow-x: hidden;*/
	}
	.blueSpan{
		cursor: pointer;
		color: #5087E4;
	}
	.right_.bottom__ .blueSpanAdd{
		cursor: pointer;
		color: #5087E4;
	}
	.el-form>>>.bottom__ .el-select .el-input.el-input--suffix i {
		line-height: 34px;
	}
	
	.el-form>>>.bottom__ .el-select .el-input.el-input--suffix input {
		height: 34px;
		border-radius: 0;
		line-height: 34px;
		/* padding: 0 !important; */
		margin: 0 !important;
	}
	
	.el-form>>>.bottom__ .el-select .el-input.el-input--suffix {
		height: 34px;
	}
	
	.el-form>>>.bottom__ .el-select {
		width: 140px;
		height: 34px;
		float: left;
	}
	
	.top_box .ljd_name {
		margin-right: 36px !important;
	}
	
	.top_box .ljd_name,
	.ljd_cx {
		line-height: 34px;
		font-size: 14px;
		margin-right: 13px;
		float: left;
	}
	.top_box .ljd_sc{
		line-height: 34px;
		font-size: 14px;
		float: left;
    	margin-left: 12px;
	}
	.el-form>>>.el-input-number__decrease,
	.el-form>>>.el-input-number__increase {
		display: none;
	}
	
	.el-form>>>.el-input-number {
		float: left;
		width: 57px;
		margin-top: -2px;
	}
	
	.errorLight {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
	}
	
	.el-form>>>.el-textarea__inner {
		border-radius: 0px !important;
	}
	
	.top_content .title {
		float: left;
		width: 60px;
		line-height: 34px;
	}
	
	.top_content .positionXY {
		float: left;
		width: 77px;
		margin-right: 21px;
	}
	
	.top_content .positionXY span {
		float: left;
		line-height: 34px;
		margin-right: 12px;
	}
	
	.el-form>>>.top_content .positionXY .el-input {
		float: left;
		width: 57px;
		height: 34px;
	}
	
	.el-form>>>.top_content .positionXY .el-input input {
		height: 34px;
		border-radius: 0px;
		text-align: center;
		width: 100%;
		padding: 0;
	}
	
	.el-form>>>.el-checkbox {
		float: left;
		width: 30%;
		line-height: 34px;
	}
	
	.top_content.active {
		color: #393939;
	}
	
	.top_content {
		width: 70%;
		float: left;
		color: #C2C2C2;
		transition: .3s;
	}
	
	.bottom__ .top_content {
		width: 220px;
		float: left;
		color: #393939;
		margin-left: 25px;
	}
	
	.bottom__ .top_content .title {
		width: 45px;
	}
	
	.top_box {
		width: 100%;
		float: left;
		margin-bottom: 8px;
		text-align: left;
	}
	
	.top__ p {
		/*margin-top: 25px;*/
		margin-bottom: 10px;
		color: #2F3A4E;
		font-size: 13px;
		text-align: left;
		float: left;
	}
	
	.bottom__ p {
		/*margin-top: 25px;*/
		margin-bottom: 10px;
		color: #2F3A4E;
		font-size: 13px;
		text-align: left;
		float: left;
		width: 100%;
	}
	
	.content_right .right_ {
		float: left;
		width: 100%;
		position: relative;
	}
	
	.top__ {
		margin-top: 25px;
	}
	
	.bottom__ {
		margin-top: 45px;
	}
	
	.content_right {
		width: 553px;
		float: left;
		position: absolute;
	    top: 64px;
	    right: 15px;
	}
	
	.el-form-item__errorMy.active {
		opacity: 1;
		transform: scaleY(1);
	}
	
	.el-form-item__errorMy {
		color: #F56C6C;
		font-size: 12px;
		line-height: 1;
		padding-top: 4px;
		position: absolute;
		top: 100%;
		left: 0;
		transition: .3s;
		opacity: 0;
		transform: scaleY(0);
	}
	
	.classifyOpa {
		font-weight: unset !important;
	}
	
	.test-box {
		position: absolute;
		width: 20px;
		height: 20px;
		background-color: red;
		border-radius: 50%;
	}
	
	.fileImgShow {
        position: absolute;
	    left: 18px;
	    right: 39px;
	    bottom: 25px;
	    top: 17px;
	    margin: auto;
	    text-align: left;
	    overflow: auto;
	}
	
	.position_xyzImg {
		position: absolute;
		right: 4px;
		bottom: 11px;
	}
	
	.position_xyImg {
		position: absolute;
		left: 4px;
		top: 4px;
	}
	
	.position_body {
	    position: relative;
	    width: 100%;
	    background: rgba(245, 245, 245, 1);
	    height: 237px;
	    /* cursor: pointer; */
	    float: left;
	    margin-top: 3px;
	    overflow: hidden;
	}
	
	.file_img p {
		color: #2c3e50;
		text-align: left;
		line-height: 17px;
		margin-bottom: 9px;
		font-size: 14px;
	}
	
	.file_img .file_img_span {
		cursor: pointer;
		color: #5087E4;
		top: 0;
		position: relative;
		float: left;
		width: 100%;
		text-align: left;
		left: 45px;
		top: 2.5px;
	}
	
	.file_img {
		float: left;
		width: 100%;
		/* padding-top: 24px; */
		margin-top: -40px;
	}
	
	.content_left {
		float: left;
		width: 582px;
		position: relative;
	}
	
	.form-mdfpwd {
		width: 100vw;
		height: 100vh;
		display: none;
		/*background: rgba(0, 0, 0, .4);*/
		position: absolute;
		top: -91px;
		bottom: 0;
		left: -250px;
		right: 0;
		z-index: 1000;
		margin: auto;
		opacity: 0;
	    transition: .2s;
	}
	
	.el-form {
		display: block;
	    width: 1136px;
	    height: 727px;
	    position: absolute;
	    margin: auto;
	    left: 0;
	    right: 0;
	    bottom: 0;
	    top: -50px;
	    -webkit-transition: .2s;
	    transition: .2s;
	    background-color: #fff;
	    border-radius: 1px;
	    padding-left: 34px;
	    padding-right: 30px;
	}
	
	.pwdhead {
		width: 100%;
		height: 63px;
		border-bottom: 1px solid #efefef;
	}
	
	.pwdhead .pwdtitle {
		float: left;
		color: #2F3A4E;
		font-size: 15px;
		margin-left: -2px;
		margin-top: 22px;
		cursor: context-menu;
	}
	
	.pwdhead .closediv {
		float: right;
		position: relative;
		margin-right: -9px;
		margin-top: 18px;
	    width: 27px;
    	height: 27px;
		cursor: pointer;
	}
	
	.pwdhead .close {
		float: right;
		position: relative;
		width: 0.1em;
		height: 1.3em;
		background: #333;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		display: inline-block;
		top: 8px;
		right: 15px;
	}
	
	.pwdhead .close:after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 0.1em;
		height: 1.3em;
		background: #333;
		-webkit-transform: rotate(270deg);
		-moz-transform: rotate(270deg);
		-o-transform: rotate(270deg);
		-ms-transform: rotate(270deg);
		transform: rotate(270deg);
	}
	
	.el-form-item {
		margin: 0;
		/* padding-left: 13px; */
		padding-top: 24px;
	}
	
	.el-form-item>>>.el-form-item__label {
		float: left;
		width: 100%;
		color: #2c3e50;
		text-align: left;
		line-height: 17px;
		margin-bottom: 9px;
	}
	
	.el-form-item>>>.el-form-item__content {
		float: left;
		width: 494px;
	}
	
	.el-form-item>>>.el-input__inner {
		padding: 0 !important;
		margin: 0 !important;
		color: #2F3030 !important;
		background: #fff !important;
		text-indent: 15px !important;
		/*border: 1px solid rgba(222, 222, 222, 1) !important;*/
		border-radius: 0px;
	}
	
	.el-form>>>.ely-button {
		background-color: #5087E4;
		color: #fff;
		width: 86px;
		letter-spacing: 1px;
		margin-top: 18px;
		font-size: 13px;
		cursor: pointer;
		border: 0;
		border-radius: 2px;
		height: 34px;
		line-height: 33px;
		position: absolute;
		left: -140px;
		right: 0;
		bottom: 28px;
		margin: auto;
		margin-top: 23px;
	}
	
	.el-form>>>.closeto {
		background-color: #FFF;
		border: 1px solid rgba(210, 210, 210, 1);
		color: #3E3D3D;
		right: -264px;
	}
	
	.el-form>>>.el-select {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/SetUp/material/Mdfrobot.vue